import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from '@/App';
import { env } from '@/utils';

// Initialize Sentry for error monitoring in production
if (env.isProduction() && env.get('VITE_SENTRY_DSN')) {
  Sentry.init({
    dsn: env.get('VITE_SENTRY_DSN'),
    environment: env.get('VITE_ENVIRONMENT'),
    integrations: [new Sentry.BrowserTracing()],
    tracesSampleRate: 0.1,
  });
}

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root element not found');
}

const root = createRoot(container);

root.render(
  <StrictMode>
    <App />
  </StrictMode>
);
